export default __webpack_public_path__ + "static/media/louise_teo.0de41e95.jpg";